var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"energy-scale"},[_c('div',{staticClass:"energy-scale__inner",style:(_vm.innerStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }